import { t } from '@lingui/macro'
import { useNavigate } from 'react-router-dom'
import styled, { useTheme } from 'styled-components'
import { useMediaQuery } from 'usehooks-ts'

import { FlexColumn, Padding } from '@/@bothrs-ui/web/components/layout'
import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { P } from '@/@bothrs-ui/web/components/typography/Body'
import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'
import { breakpoints } from '@/config/layout'
import { ContentImageLayout } from '@/layout/components/content-image-layout/ContentImageLayout'

type Props = {
  title?: string
  description?: string
  buttonLabel?: string
  image?: string
  imagePositionDesktop?: React.CSSProperties['objectPosition']
}

export const SuccessStep = ({
  title = t({
    id: 'app-question.successfully-sent.title',
    message: 'Bedankt!',
  }),
  description = t({
    id: 'app-question.successfully-sent.description',
    message: 'We doen ons best om je vraag zo snel mogelijk te beantwoorden.',
  }),
  buttonLabel = t({
    id: 'globals.continue',
    message: 'Doorgaan',
  }),
  image = '/img/wheelchair-patient.jpg',
  imagePositionDesktop = 'center 25%',
}: Props) => {
  const theme = useTheme()
  const navigate = useNavigate()

  const isMobile = useMediaQuery(breakpoints.toS)
  const imagePosition: React.CSSProperties['objectPosition'] = isMobile ? undefined : imagePositionDesktop

  const handleClose = () => {
    navigate('/home')
  }

  return (
    <ContentImageLayout image={image} imagePosition={imagePosition}>
      <StContentContainer gap={theme.UI.Spacing.Space4}>
        <H3 noMargin>{title}</H3>

        <P type='BodyMediumRegular' style={{ fontWeight: 400 }}>
          {description}
        </P>

        <Padding pt={theme.UI.Spacing.Space8}>
          <Button variant='Primary' onClick={handleClose}>
            {buttonLabel}
          </Button>
        </Padding>
      </StContentContainer>
    </ContentImageLayout>
  )
}

const StContentContainer = styled(FlexColumn)`
  flex-grow: 1;
  max-width: 600px;
`
